import EventStatWidgetEditDialog from "./EventStatWidgetEditDialog/EventStatWidgetEditDialog";
import FighterRecordWidgetEditDialog from "./FighterRecordWidgetEditDialog/FighterRecordWidgetEditDialog";
import OnlineTextWidgetEditDialog from "./OnlineTextWidgetEditDialog/OnlineTextWidgetEditDialog";
import FighterStatWidgetEditDialog from "./FighterStatWidgetEditDialog/FighterStatWidgetEditDialog";
import FighterCompareStatWidgetEditDialog
	from "./FighterCompareStatWidgetEditDialog/FighterCompareStatWidgetEditDialog";
import FighterCompareWidgetEditDialog from "./FighterCompareWidgetEditDialog/FighterCompareWidgetEditDialog";
import FighterCardWidgetEditDialog from "./FighterCardWidgetEditDialog/FighterCardWidgetEditDialog";

export enum WidgetType {
	EventStat = 'EventStat',
	FighterStat = 'FighterStat',
	OnlineText = 'OnlineText',
	FighterCompareStat = 'FighterCompareStat',
	FighterCompare = 'FighterCompare',
	FighterRecord = "FighterRecord",
	FighterCard = 'FighterCard'
}


export const WLIST = {
	[WidgetType.EventStat]: {
		Name: 'Event Stat',
		ClassName: 'event-stat',
		Class: EventStatWidgetEditDialog
	},
	[WidgetType.FighterStat]: {
		Name: 'Fighter Stats',
		ClassName: 'fighter-stat',
		Class: FighterStatWidgetEditDialog
	},
	[WidgetType.FighterCompareStat]: {
		Name: 'Fighters Stat Compare',
		ClassName: 'fighter-compare-stat',
		Class: FighterCompareStatWidgetEditDialog
	},
	[WidgetType.FighterCompare]: {
		Name: 'Fighters Compare',
		ClassName: 'fighter-compare',
		Class: FighterCompareWidgetEditDialog
	},
	[WidgetType.OnlineText]: {
		Name: 'Online fight Text',
		ClassName: 'online-text',
		Class: OnlineTextWidgetEditDialog
	},
	[WidgetType.FighterRecord]: {
		Name: 'Fighter Record',
		ClassName: 'fighter-record',
		Class: FighterRecordWidgetEditDialog
	},
	[WidgetType.FighterCard]: {
		Name: 'Fighter Card',
		ClassName: 'fighter-card',
		Class: FighterCardWidgetEditDialog
	}
}